export const canGoBack = (location) => !!location.state;
